export default {
    我已阅读并同意: 'I have read and agree to',
    用户协议: 'User Agreement',
    隐私声明: 'Privacy Statement',
    '，并授权复星财富获得MyLink登录手机号': ', and authorize Fosun Wealth to access MyLink login phone number',
    '登录/注册': 'Login/Register',
    请阅读并勾选用户协议: 'Please read and check the user agreement',
    '服务器连接中，请稍后再试': 'Connecting to server, please try again later',
    '当前系统版本过低，请升级': 'Your system version is too low, please upgrade',
    '暂不支持当前账户类型通过MyLink使用复星财富服务。': 'This account type is not supported for Fosun Wealth services via MyLink.',
    '如有疑问，请致电': 'For questions, please call',
    '联系复星财富客服。': 'Contact Fosun Wealth customer service.',
}
